import Services from "../../../services";

class HakAksesDivisiApi {
  get(id, kode) {
    return Services.get(
      `/hrda/hak_akses/karyawan/?id_karyawan=${id}&tipe_hak_akses=menu&kode_hak_akses_parent=${kode}`
    );
  }
  getDropdown() {
    return Services.get("/hrda/karyawan/");
  }
  getDivisi() {
    return Services.get("/hrda/hak_akses/?tipe_hak_akses=divisi");
  }
  create(value) {
    return Services.post("/hrda/hak_akses/karyawan/", value);
  }
}

export default new HakAksesDivisiApi();
